import { consoleRequest } from '@/console/api/http'
import { ReturnOriginRemapRequest, ReturnOriginRemapResponse } from '@/console/api/types'

/**
 * 반품 입고실적 원주문 재매핑(docs/ONCALL_RETURN_ORIGIN_REMAP_API.md). 인가는 `MOMS_ENG` 단독이다.
 * 성공·거부 모두 200 의 raw DTO 라 언랩하지 않고, 거부 판정은 호출부가 `outcome` 으로 한다.
 * 비멱등이라 재시도하지 않는다.
 */
export const RETURN_ORIGIN_REMAP_URL = '/api/v1/inbound/return-inbound/origin-remap'

export const requestReturnOriginRemap = (request: ReturnOriginRemapRequest): Promise<ReturnOriginRemapResponse> =>
  consoleRequest.post<ReturnOriginRemapResponse, ReturnOriginRemapRequest>(RETURN_ORIGIN_REMAP_URL, request)
